// evaluationData.js - Dómaupplýsingar fyrir hross frá Hólabaki

export const evaluationData = [
    {
        "id": "IS2020256275",
        "name": "Heiðrún",
        "origin": "Hólabaki",
        "colorCode": "27000",
        "country": "IS",
        "year": 2025,
        "competition": "Miðsumarssýning Rangárbökkum, dagana 14. til 18. júlí.",
        "judgeCountry": "IS",
        "exhibitor": "Helga Una Björnsdóttir",
        "owner": "Björn Magnússon",
        "m1": "143",
        "conformation": 7.86,
        "abilities": 7.85,
        "totalScore": 7.85,
        "abilitiesNoGait": 8.36,
        "totalScoreNoGait": 8.19,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2018156275",
        "name": "Hvinur",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2024,
        "competition": "Vorsýning Hólum í Hjaltadal, vikuna 10. til 14. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Karel Guðmundur Halldórsson, Lárus Bjarni Guttormsson, Magnús Kristinsson, Rafnar Karl Rafnarsson",
        "m1": "143",
        "conformation": 8.43,
        "abilities": 8.02,
        "totalScore": 8.16,
        "abilitiesNoGait": 7.84,
        "totalScoreNoGait": 8.04,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2019256277",
        "name": "Elsa",
        "origin": "Hólabaki",
        "colorCode": "25100",
        "country": "IS",
        "year": 2024,
        "competition": "Vorsýning Hólum í Hjaltadal, vikuna 10. til 14. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Björn Magnússon",
        "m1": "141",
        "conformation": 7.86,
        "abilities": 8.1,
        "totalScore": 8.02,
        "abilitiesNoGait": 8.12,
        "totalScoreNoGait": 8.03,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2019256276",
        "name": "Glóey",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "IS",
        "year": 2024,
        "competition": "Vorsýning Hólum í Hjaltadal, vikuna 10. til 14. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Hólabaksbúið ehf.",
        "m1": "141",
        "conformation": 8.09,
        "abilities": 8.03,
        "totalScore": 8.05,
        "abilitiesNoGait": 8.04,
        "totalScoreNoGait": 8.06,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2019256275",
        "name": "Hugrún",
        "origin": "Hólabaki",
        "colorCode": "12000",
        "country": "IS",
        "year": 2024,
        "competition": "Síðsumarssýning á Rangárbökkum við Hellu, dagana 12. til 16. ágúst.",
        "judgeCountry": "IS",
        "exhibitor": "Helga Una Björnsdóttir",
        "owner": "Hjörtur Karl Einarsson, Sigríður S Sigþórsdóttir",
        "m1": "144",
        "conformation": 8.27,
        "abilities": 7.87,
        "totalScore": 8.01,
        "abilitiesNoGait": 8.39,
        "totalScoreNoGait": 8.35,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2014256270",
        "name": "Fregn",
        "origin": "Hólabaki",
        "colorCode": "75000",
        "country": "IS",
        "year": 2023,
        "competition": "Síðsumarssýning á Rangárbökkum við Hellu, dagana 21. til 24. ágúst.",
        "judgeCountry": "IS",
        "exhibitor": "Jón Finnur Hansson",
        "owner": "Jón Finnur Hansson",
        "m1": "140",
        "conformation": 8.18,
        "abilities": 7.62,
        "totalScore": 7.81,
        "abilitiesNoGait": 8.09,
        "totalScoreNoGait": 8.12,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2019256277",
        "name": "Elsa",
        "origin": "Hólabaki",
        "colorCode": "25100",
        "country": "IS",
        "year": 2023,
        "competition": "Vorsýning Hólum í Hjaltadal, dagana 12. til 16. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Björn Magnússon",
        "m1": "144",
        "conformation": 7.86,
        "abilities": 7.58,
        "totalScore": 7.68,
        "abilitiesNoGait": 7.59,
        "totalScoreNoGait": 7.69,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2017156275",
        "name": "Hugur",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2023,
        "competition": "Vorsýning Gaddstaðaflötum, dagana 12. til 16. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Steingrímur Sigurðsson",
        "owner": "Georg Kristjánsson, Sigurður Sigurðsson",
        "m1": "145",
        "conformation": 8.46,
        "abilities": 8.33,
        "totalScore": 8.38,
        "abilitiesNoGait": 8.94,
        "totalScoreNoGait": 8.77,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2015256270",
        "name": "Arna",
        "origin": "Hólabaki",
        "colorCode": "02000",
        "country": "IS",
        "year": 2023,
        "competition": "Miðsumarssýning Rangárbökkum við Hellu, 17.-21. júlí.",
        "judgeCountry": "IS",
        "exhibitor": "Helga Una Björnsdóttir",
        "owner": "Helga Una Björnsdóttir, Hrossaræktarbúið Hamarsey",
        "m1": "140",
        "conformation": 8.42,
        "abilities": 8.55,
        "totalScore": 8.5,
        "abilitiesNoGait": 8.83,
        "totalScoreNoGait": 8.69,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2015256270",
        "name": "Arna",
        "origin": "Hólabaki",
        "colorCode": "02000",
        "country": "IS",
        "year": 2023,
        "competition": "Vorsýning Gaddstaðaflötum, dagana 5. til 9. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Helga Una Björnsdóttir",
        "owner": "Helga Una Björnsdóttir, Hrossaræktarbúið Hamarsey",
        "m1": "140",
        "conformation": 8.42,
        "abilities": 7.98,
        "totalScore": 8.13,
        "abilitiesNoGait": 8.52,
        "totalScoreNoGait": 8.48,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2019256276",
        "name": "Glóey",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "IS",
        "year": 2023,
        "competition": "Vorsýning Hólum í Hjaltadal, dagana 12. til 16. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Hólabaksbúið ehf.",
        "m1": "140",
        "conformation": 7.97,
        "abilities": 8.06,
        "totalScore": 8.03,
        "abilitiesNoGait": 8.35,
        "totalScoreNoGait": 8.21,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2012256275",
        "name": "Hera",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2022,
        "competition": "Síðsumarauki á Gaddstaðaflötum, dagana 22. til 23. ágúst.",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Sóley Ásta Karlsdóttir",
        "m1": "144",
        "conformation": 7.98,
        "abilities": 7.7,
        "totalScore": 7.8,
        "abilitiesNoGait": 7.65,
        "totalScoreNoGait": 7.76,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2015256270",
        "name": "Arna",
        "origin": "Hólabaki",
        "colorCode": "02000",
        "country": "IS",
        "year": 2022,
        "competition": "Síðsumarauki á Gaddstaðaflötum, dagana 22. til 23. ágúst.",
        "judgeCountry": "IS",
        "exhibitor": "Helga Una Björnsdóttir",
        "owner": "Helga Una Björnsdóttir, Hrossaræktarbúið Hamarsey",
        "m1": "140",
        "conformation": 8.42,
        "abilities": 7.88,
        "totalScore": 8.07,
        "abilitiesNoGait": 8.41,
        "totalScoreNoGait": 8.41,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2017156275",
        "name": "Hugur",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2022,
        "competition": "Vorsýning Gaddstaðaflötum, dagana 30. maí til 4. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Steingrímur Sigurðsson",
        "owner": "Georg Kristjánsson, Sigurður Sigurðsson",
        "m1": "144",
        "conformation": 8.43,
        "abilities": 8.11,
        "totalScore": 8.22,
        "abilitiesNoGait": 8.67,
        "totalScoreNoGait": 8.59,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2016256275",
        "name": "Sónata",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2022,
        "competition": "Vorsýning Hólum í Hjaltadal, dagana 13. til 16. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Mette Camilla Moe Mannseth",
        "owner": "Björn Magnússon, Hólabaksbúið ehf., Sigríður S Sigþórsdóttir",
        "m1": "143",
        "conformation": 8.46,
        "abilities": 8.02,
        "totalScore": 8.18,
        "abilitiesNoGait": 7.94,
        "totalScoreNoGait": 8.12,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2012256275",
        "name": "Hera",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2022,
        "competition": "Vorsýning Spretti í Kópavogi, dagana 7. júní til 9. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Sóley Ásta Karlsdóttir",
        "m1": "144",
        "conformation": 7.98,
        "abilities": 7.77,
        "totalScore": 7.84,
        "abilitiesNoGait": 7.64,
        "totalScoreNoGait": 7.76,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2016256275",
        "name": "Sónata",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2022,
        "competition": "Vorsýning Hólum í Hjaltadal, dagana 7. til 9. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Mette Camilla Moe Mannseth",
        "owner": "Björn Magnússon, Hólabaksbúið ehf., Sigríður S Sigþórsdóttir",
        "m1": "142",
        "conformation": 8.42,
        "abilities": 7.85,
        "totalScore": 8.05,
        "abilitiesNoGait": 7.74,
        "totalScoreNoGait": 7.98,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2017156275",
        "name": "Hugur",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2022,
        "competition": "Landsmót hestamanna 2022, Gaddstaðaflötum við Hellu.",
        "judgeCountry": "IS",
        "exhibitor": "Steingrímur Sigurðsson",
        "owner": "Georg Kristjánsson, Sigurður Sigurðsson",
        "m1": "144",
        "conformation": 8.43,
        "abilities": 8.08,
        "totalScore": 8.2,
        "abilitiesNoGait": 8.64,
        "totalScoreNoGait": 8.56,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2015256275",
        "name": "Harpa",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2021,
        "competition": "Vorsýning Akureyri, dagana 7. til 10. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Anna Kristín Friðriksdóttir",
        "owner": "Sigurður Torfi Grétarsson",
        "m1": "140",
        "conformation": 8.04,
        "abilities": 7.57,
        "totalScore": 7.74,
        "abilitiesNoGait": 7.76,
        "totalScoreNoGait": 7.86,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2012256276",
        "name": "Sigurrós",
        "origin": "Hólabaki",
        "colorCode": "85000",
        "country": "IS",
        "year": 2021,
        "competition": "Vorsýning Akureyri, dagana 7. til 10. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "146",
        "conformation": 8.27,
        "abilities": 7.38,
        "totalScore": 7.7,
        "abilitiesNoGait": 7.36,
        "totalScoreNoGait": 7.68,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2017256276",
        "name": "Glóblesa",
        "origin": "Hólabaki",
        "colorCode": "15500",
        "country": "IS",
        "year": 2021,
        "competition": "Síðsumarssýning á Hólum í Hjaltadal dagana 16. til 19. ágúst.",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Hólabaksbúið ehf.",
        "m1": "140",
        "conformation": 7.83,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS2015256274",
        "name": "Snót",
        "origin": "Hólabaki",
        "colorCode": "06000",
        "country": "IS",
        "year": 2021,
        "competition": "Vorsýning Hólum í Hjaltadal, dagana 2. til 4. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "140",
        "conformation": 8.36,
        "abilities": 7.66,
        "totalScore": 7.91,
        "abilitiesNoGait": 7.6,
        "totalScoreNoGait": 7.87,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2015256275",
        "name": "Harpa",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2021,
        "competition": "Miðsumarssýning Hólum í Hjaltadal, dagana 20. til 22. júlí.",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Sigurður Torfi Grétarsson",
        "m1": "140",
        "conformation": 8.04,
        "abilities": 8.08,
        "totalScore": 8.07,
        "abilitiesNoGait": 8.18,
        "totalScoreNoGait": 8.13,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2016256275",
        "name": "Sónata",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2021,
        "competition": "Síðsumarssýning á Hólum í Hjaltadal dagana 16. til 19. ágúst.",
        "judgeCountry": "IS",
        "exhibitor": "Gísli Gíslason",
        "owner": "Björn Magnússon, Hólabaksbúið ehf., Sigríður S Sigþórsdóttir",
        "m1": "142",
        "conformation": 8.49,
        "abilities": 7.74,
        "totalScore": 8,
        "abilitiesNoGait": 7.6,
        "totalScoreNoGait": 7.91,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2015256274",
        "name": "Snót",
        "origin": "Hólabaki",
        "colorCode": "06000",
        "country": "IS",
        "year": 2021,
        "competition": "Miðsumarssýning Hólum í Hjaltadal, dagana 20. til 22. júlí.",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "140",
        "conformation": 8.36,
        "abilities": 7.95,
        "totalScore": 8.09,
        "abilitiesNoGait": 7.94,
        "totalScoreNoGait": 8.09,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2007156274",
        "name": "Seifur",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "SE",
        "year": 2021,
        "competition": "Axevalla 1",
        "judgeCountry": "SE",
        "exhibitor": "Sigurjón Örn Björnsson",
        "owner": "Bjarki Freyr Arngrímsson kt: IS1002952969",
        "m1": "145",
        "conformation": 8.19,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2015256274",
        "name": "Snót",
        "origin": "Hólabaki",
        "colorCode": "06000",
        "country": "IS",
        "year": 2020,
        "competition": "Vorsýning -Hólum í Hjaltadal, dagana 15. til 19. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Björn Magnússon",
        "m1": "142",
        "conformation": 8.36,
        "abilities": 7.33,
        "totalScore": 7.69,
        "abilitiesNoGait": 7.21,
        "totalScoreNoGait": 7.61,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2012256270",
        "name": "Grótta",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "IS",
        "year": 2020,
        "competition": "Miðsumarssýning á Gaddstaðaflötum - 3. vika, 27.-31. júlí.",
        "judgeCountry": "IS",
        "exhibitor": "Jón Finnur Hansson",
        "owner": "Jón Finnur Hansson",
        "m1": "144",
        "conformation": 7.76,
        "abilities": 7.79,
        "totalScore": 7.78,
        "abilitiesNoGait": 8.03,
        "totalScoreNoGait": 7.94,
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS2012256275",
        "name": "Hera",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2020,
        "competition": "Síðsumarssýning á Gaddstaðaflötum við Hellu dagana 17. til 21. ágúst.",
        "judgeCountry": "IS",
        "exhibitor": "Ævar Örn Guðjónsson",
        "owner": "Sóley Ásta Karlsdóttir",
        "m1": "145",
        "conformation": 7.98,
        "abilities": 7.52,
        "totalScore": 7.68,
        "abilitiesNoGait": 7.62,
        "totalScoreNoGait": 7.74,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2007156274",
        "name": "Seifur",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "SE",
        "year": 2020,
        "competition": "Axevalla 1",
        "judgeCountry": "SE",
        "exhibitor": "Sigurjón Örn Björnsson",
        "owner": "Bjarki Freyr Arngrímsson kt: IS1002952969",
        "m1": "146",
        "conformation": 8.37,
        "abilities": 7.68,
        "totalScore": 7.93,
        "abilitiesNoGait": 7.72,
        "totalScoreNoGait": 7.95,
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156275",
        "name": "Hamur",
        "origin": "Hólabaki",
        "colorCode": "15200",
        "country": "DK",
        "year": 2019,
        "competition": "World Championships 2019 Berlin",
        "judgeCountry": "DE",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Anna Christine Ulbæk, Stald Ulbæk v. Sus Ulbæk",
        "m1": "145",
        "conformation": 8.5,
        "abilities": 8.39,
        "totalScore": 8.44,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156275",
        "name": "Hamur",
        "origin": "Hólabaki",
        "colorCode": "15200",
        "country": "DK",
        "year": 2019,
        "competition": "FIZO Verden",
        "judgeCountry": "DE",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Anna Christine Ulbæk, Stald Ulbæk v. Sus Ulbæk",
        "m1": "144",
        "conformation": 8.39,
        "abilities": 8.55,
        "totalScore": 8.49,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156274",
        "name": "Stormur",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "DK",
        "year": 2019,
        "competition": "FIZO Verden",
        "judgeCountry": "DE",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Stald Ulbæk v. Sus Ulbæk",
        "m1": "143",
        "conformation": 8.37,
        "abilities": 8.5,
        "totalScore": 8.45,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156275",
        "name": "Hamur",
        "origin": "Hólabaki",
        "colorCode": "15200",
        "country": "DK",
        "year": 2019,
        "competition": "Kåring 1 Herning",
        "judgeCountry": "DK",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Anna Christine Ulbæk, Stald Ulbæk v. Sus Ulbæk",
        "m1": "144",
        "conformation": 8.31,
        "abilities": 8.43,
        "totalScore": 8.39,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156274",
        "name": "Stormur",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "DK",
        "year": 2019,
        "competition": "Kåring 1 Herning",
        "judgeCountry": "DK",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Stald Ulbæk v. Sus Ulbæk",
        "m1": "145",
        "conformation": 8.33,
        "abilities": 8.43,
        "totalScore": 8.39,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2015156275",
        "name": "Fengur",
        "origin": "Hólabaki",
        "colorCode": "27000",
        "country": "DE",
        "year": 2019,
        "competition": "Vorsýning á Akureyri, 18. til 20. júní.",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Björn Magnússon",
        "m1": "143",
        "conformation": 8.22,
        "abilities": 7.74,
        "totalScore": 7.93,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2013256274",
        "name": "Djörfung",
        "origin": "Hólabaki",
        "colorCode": "15500",
        "country": "DE",
        "year": 2019,
        "competition": "Miðsumarssýning á Gaddstaðaflötum við Hellu -seinni vika 22. til 26. júlí.",
        "judgeCountry": "IS",
        "exhibitor": "Jakob Svavar Sigurðsson",
        "owner": "Anne-Katrin Rieckhoff, Sven Rieckhoff",
        "m1": "141",
        "conformation": 8.16,
        "abilities": 7.69,
        "totalScore": 7.88,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2013256274",
        "name": "Djörfung",
        "origin": "Hólabaki",
        "colorCode": "15500",
        "country": "DE",
        "year": 2019,
        "competition": "Síðsumarssýning Brávöllum á Selfossi,",
        "judgeCountry": "IS",
        "exhibitor": "Jakob Svavar Sigurðsson",
        "owner": "Anne-Katrin Rieckhoff, Sven Rieckhoff",
        "m1": "141",
        "conformation": 8.16,
        "abilities": 7.96,
        "totalScore": 8.04,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2010156275",
        "name": "Sómi",
        "origin": "Hólabaki",
        "colorCode": "62000",
        "country": "DE",
        "year": 2018,
        "competition": "FIZO St. Radegund 2018",
        "judgeCountry": "AT",
        "exhibitor": "Thorsten Reisinger",
        "owner": "Nathalie Müller",
        "m1": "144",
        "conformation": 8.37,
        "abilities": 8.48,
        "totalScore": 8.43,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156274",
        "name": "Stormur",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "DK",
        "year": 2018,
        "competition": "Landsmót í Víðidal",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Stald Ulbæk v. Sus Ulbæk",
        "m1": "141",
        "conformation": 8.26,
        "abilities": 7.94,
        "totalScore": 8.07,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156275",
        "name": "Hamur",
        "origin": "Hólabaki",
        "colorCode": "15200",
        "country": "DK",
        "year": 2018,
        "competition": "Landsmót í Víðidal",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Anna Christine Ulbæk, Stald Ulbæk v. Sus Ulbæk",
        "m1": "145",
        "conformation": 8.24,
        "abilities": 7.75,
        "totalScore": 7.95,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156274",
        "name": "Stormur",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "DK",
        "year": 2018,
        "competition": "Vorsýning Hólum í Hjaltadal -fyrri vika 4. til 8. júní",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Stald Ulbæk v. Sus Ulbæk",
        "m1": "141",
        "conformation": 8.26,
        "abilities": 8.15,
        "totalScore": 8.19,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2014156275",
        "name": "Hamur",
        "origin": "Hólabaki",
        "colorCode": "15200",
        "country": "DK",
        "year": 2018,
        "competition": "Vorsýning Hólum í Hjaltadal -fyrri vika 4. til 8. júní",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Anna Christine Ulbæk, Stald Ulbæk v. Sus Ulbæk",
        "m1": "145",
        "conformation": 8.24,
        "abilities": 7.91,
        "totalScore": 8.04,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2011256276",
        "name": "Perla",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "IS",
        "year": 2018,
        "competition": "Síðsumarssýning á Gaddstaðaflötum við Hellu 20. til 24. ágúst",
        "judgeCountry": "IS",
        "exhibitor": "Leó Geir Arnarson",
        "owner": "Rúnar Örn Guðmundsson",
        "m1": "143",
        "conformation": 8.05,
        "abilities": 7.74,
        "totalScore": 7.86,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2010156275",
        "name": "Sómi",
        "origin": "Hólabaki",
        "colorCode": "62000",
        "country": "DE",
        "year": 2017,
        "competition": "FIZO-Kronshof Sommer",
        "judgeCountry": "DE",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Nathalie Müller",
        "m1": "144",
        "conformation": 8.26,
        "abilities": 8.43,
        "totalScore": 8.36,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2010256275",
        "name": "Rauðbrá",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "NL",
        "year": 2017,
        "competition": "Miðsumarssýning I Gaddstaðaflötum við Hellu.",
        "judgeCountry": "IS",
        "exhibitor": "Guðmundur Friðrik Björgvinsson",
        "owner": "Vera van Praag Sigaar",
        "m1": "145",
        "conformation": 8.22,
        "abilities": 8.2,
        "totalScore": 8.21,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2009256274",
        "name": "Dís",
        "origin": "Hólabaki",
        "colorCode": "15300",
        "country": "IS",
        "year": 2016,
        "competition": "Miðsumarssýning Brávöllum á Selfossi",
        "judgeCountry": "IS",
        "exhibitor": "Jón Finnur Hansson",
        "owner": "Jón Finnur Hansson",
        "m1": "140",
        "conformation": 7.99,
        "abilities": 8.33,
        "totalScore": 8.2,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2011256276",
        "name": "Perla",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "IS",
        "year": 2015,
        "competition": "Víðidalur í Reykjavík",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Rúnar Örn Guðmundsson",
        "m1": "143",
        "conformation": 7.99,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2010156275",
        "name": "Sómi",
        "origin": "Hólabaki",
        "colorCode": "62000",
        "country": "DE",
        "year": 2015,
        "competition": "Aukasýning í Spretti",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Nathalie Müller",
        "m1": "146",
        "conformation": 8.26,
        "abilities": 7.87,
        "totalScore": 8.02,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2008256274",
        "name": "Ára",
        "origin": "Hólabaki",
        "colorCode": "01000",
        "country": "IS",
        "year": 2014,
        "competition": "Síðsumarssýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Þórarinn Eymundsson",
        "owner": "Svavar Örn Halldórsson",
        "m1": "140",
        "conformation": 8.04,
        "abilities": 7.88,
        "totalScore": 7.95,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2010156275",
        "name": "Sómi",
        "origin": "Hólabaki",
        "colorCode": "62000",
        "country": "DE",
        "year": 2014,
        "competition": "Borgarfjörður, seinni vika",
        "judgeCountry": "IS",
        "exhibitor": "Gísli Gíslason",
        "owner": "Nathalie Müller",
        "m1": "145",
        "conformation": 8.24,
        "abilities": 7.44,
        "totalScore": 7.76,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2004156275",
        "name": "Gígur",
        "origin": "Hólabaki",
        "colorCode": "09000",
        "country": "NO",
        "year": 2013,
        "competition": "Herning",
        "judgeCountry": "DK",
        "exhibitor": "Rasmus Møller Jensen",
        "owner": "Trine Jonassen",
        "m1": "141",
        "conformation": 7.93,
        "abilities": 7.86,
        "totalScore": 7.89,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2009156274",
        "name": "Davíð",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "IS",
        "year": 2013,
        "competition": "Héraðssýning á Hvammstanga 21. maí til 24. maí",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon, Tryggvi Björnsson",
        "m1": "144",
        "conformation": 8.21,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS2008256275",
        "name": "Spyrna",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2013,
        "competition": "Síðsumarssýning á Blönduósi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "138",
        "conformation": 7.89,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2008256274",
        "name": "Ára",
        "origin": "Hólabaki",
        "colorCode": "01000",
        "country": "IS",
        "year": 2013,
        "competition": "Héraðssýning á Hvammstanga 21. maí til 24. maí",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Svavar Örn Halldórsson",
        "m1": "139",
        "conformation": 8.04,
        "abilities": 7.51,
        "totalScore": 7.72,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2008156272",
        "name": "Kjalar",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2012,
        "competition": "Héraðssýning á Hvammstanga",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon, Gabríel Óli Ólafsson",
        "m1": "143",
        "conformation": 7.71,
        "abilities": 7.29,
        "totalScore": 7.46,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2004256276",
        "name": "Vaka",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "FI",
        "year": 2012,
        "competition": "Síðsumarsýning á Vesturlandi",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Ann-Christine Väyrynen",
        "m1": "145",
        "conformation": 8.28,
        "abilities": 7.86,
        "totalScore": 8.03,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2007256275",
        "name": "Gullbrá",
        "origin": "Hólabaki",
        "colorCode": "16200",
        "country": "IS",
        "year": 2012,
        "competition": "Héraðssýning á Gaddstaðaflötum",
        "judgeCountry": "IS",
        "exhibitor": "Árni Björn Pálsson",
        "owner": "Bjarni Bjarnason, Tjaldhóll ehf",
        "m1": "140",
        "conformation": 8.09,
        "abilities": 7.78,
        "totalScore": 7.91,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS2002156274",
        "name": "Heiðar",
        "origin": "Hólabaki",
        "colorCode": "15210",
        "country": "NO",
        "year": 2011,
        "competition": "Herning",
        "judgeCountry": "DK",
        "exhibitor": "Erlingur Erlingsson",
        "owner": "Ármann Ólafsson",
        "m1": "143",
        "conformation": 8.2,
        "abilities": 7.82,
        "totalScore": 7.97,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2004256277",
        "name": "Dimma",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "GB",
        "year": 2011,
        "competition": "Orchardleigh",
        "judgeCountry": "GB",
        "exhibitor": "Smári Slater",
        "owner": "Ann Savage",
        "m1": "138",
        "conformation": 7.63,
        "abilities": 7.19,
        "totalScore": 7.37,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2006256275",
        "name": "Heiðdís",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2011,
        "competition": "Landsmót 2011 - Vindheimamelar",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Björn Magnússon",
        "m1": "143",
        "conformation": 8.24,
        "abilities": 8.1,
        "totalScore": 8.15,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2007256275",
        "name": "Gullbrá",
        "origin": "Hólabaki",
        "colorCode": "16200",
        "country": "IS",
        "year": 2011,
        "competition": "Héraðssýning á Hvammstanga",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Bjarni Bjarnason, Tjaldhóll ehf",
        "m1": "135",
        "conformation": 7.99,
        "abilities": 7.6,
        "totalScore": 7.76,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS2004156275",
        "name": "Gígur",
        "origin": "Hólabaki",
        "colorCode": "09000",
        "country": "NO",
        "year": 2011,
        "competition": "Héraðssýning Sörlastöðum",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Óli Kristinsson",
        "owner": "Trine Jonassen",
        "m1": "144",
        "conformation": 8.08,
        "abilities": 7.95,
        "totalScore": 8,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2005256277",
        "name": "Saga",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "IS",
        "year": 2011,
        "competition": "Síðsumarsýning Vesturlands",
        "judgeCountry": "IS",
        "exhibitor": "Guðmundur Friðrik Björgvinsson",
        "owner": "Einar Víðir Einarsson, Þorgrímur Jóel Þórðarson",
        "m1": "141",
        "conformation": 7.94,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2006256275",
        "name": "Heiðdís",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2011,
        "competition": "Héraðssýning á Hvammstanga",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Björn Magnússon",
        "m1": "143",
        "conformation": 8.24,
        "abilities": 8.17,
        "totalScore": 8.2,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2006156275",
        "name": "Stígur",
        "origin": "Hólabaki",
        "colorCode": "",
        "country": "IS",
        "year": 2011,
        "competition": "Héraðssýning á Stekkhólma",
        "judgeCountry": "IS",
        "exhibitor": "Nikólína Ósk Rúnarsdóttir",
        "owner": "Sóley Ásta Karlsdóttir",
        "m1": "141",
        "conformation": 7.63,
        "abilities": 7.35,
        "totalScore": 7.46,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2007256275",
        "name": "Gullbrá",
        "origin": "Hólabaki",
        "colorCode": "16200",
        "country": "IS",
        "year": 2011,
        "competition": "Kynbótasýning Akureyri",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Bjarni Bjarnason, Tjaldhóll ehf",
        "m1": "137",
        "conformation": 7.99,
        "abilities": 7.4,
        "totalScore": 7.64,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS2003156275",
        "name": "Geisli",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "NL",
        "year": 2010,
        "competition": "FIZO Berlar",
        "judgeCountry": "DE",
        "exhibitor": "Jolly Schrenk",
        "owner": "Mw. Bowie Hagen",
        "m1": "147",
        "conformation": 8.02,
        "abilities": 7.56,
        "totalScore": 7.75,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2004256276",
        "name": "Vaka",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "FI",
        "year": 2010,
        "competition": "Síðsumarsýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Birna Tryggvadóttir Thorlacius",
        "owner": "Ann-Christine Väyrynen",
        "m1": "143",
        "conformation": 8.22,
        "abilities": 7.62,
        "totalScore": 7.86,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2005256275",
        "name": "Líf",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "IS",
        "year": 2010,
        "competition": "Vorsýning á Blönduósi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "144",
        "conformation": 7.89,
        "abilities": 7.11,
        "totalScore": 7.42,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2005256275",
        "name": "Líf",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "IS",
        "year": 2010,
        "competition": "Síðsumarsýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "143",
        "conformation": 7.89,
        "abilities": 7.78,
        "totalScore": 7.83,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2006256275",
        "name": "Heiðdís",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2010,
        "competition": "Síðsumarsýning á Vesturlandi",
        "judgeCountry": "IS",
        "exhibitor": "Agnar Þór Magnússon",
        "owner": "Björn Magnússon",
        "m1": "141",
        "conformation": 8.04,
        "abilities": 7.73,
        "totalScore": 7.85,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2004156275",
        "name": "Gígur",
        "origin": "Hólabaki",
        "colorCode": "09000",
        "country": "NO",
        "year": 2010,
        "competition": "Seinni Héraðssýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Trine Jonassen",
        "m1": "140",
        "conformation": 8.07,
        "abilities": 8.08,
        "totalScore": 8.08,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2005256275",
        "name": "Líf",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "IS",
        "year": 2009,
        "competition": "Héraðssýning á Blönduósi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "144",
        "conformation": 7.94,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2005256275",
        "name": "Líf",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "IS",
        "year": 2009,
        "competition": "Síðsumarsýning á Blönduósi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "143",
        "conformation": 7.87,
        "abilities": 7.29,
        "totalScore": 7.52,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2004256276",
        "name": "Vaka",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "FI",
        "year": 2009,
        "competition": "Síðsumarsýning á Blönduósi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Ann-Christine Väyrynen",
        "m1": "144",
        "conformation": 8.22,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2004256277",
        "name": "Dimma",
        "origin": "Hólabaki",
        "colorCode": "25000",
        "country": "GB",
        "year": 2009,
        "competition": "Vorsýning kynbótahrossa á Sauðárkróki",
        "judgeCountry": "IS",
        "exhibitor": "Ólafur Magnússon",
        "owner": "Ann Savage",
        "m1": "140",
        "conformation": 7.61,
        "abilities": 7.59,
        "totalScore": 7.6,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2003156270",
        "name": "Sigur",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "AT",
        "year": 2009,
        "competition": "Héraðssýning á Stekkhólma",
        "judgeCountry": "IS",
        "exhibitor": "Hans Friðrik Kjerulf",
        "owner": "Mag. Gerrit Sager",
        "m1": "140",
        "conformation": 8.44,
        "abilities": 8.33,
        "totalScore": 8.37,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2003156270",
        "name": "Sigur",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "AT",
        "year": 2008,
        "competition": "Landsmót 2008 - Hella",
        "judgeCountry": "IS",
        "exhibitor": "Hans Friðrik Kjerulf",
        "owner": "Mag. Gerrit Sager",
        "m1": "141",
        "conformation": 8.26,
        "abilities": 8.33,
        "totalScore": 8.3,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2003156270",
        "name": "Sigur",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "AT",
        "year": 2008,
        "competition": "Héraðssýning á Stekkhólma",
        "judgeCountry": "IS",
        "exhibitor": "Hans Friðrik Kjerulf",
        "owner": "Mag. Gerrit Sager",
        "m1": "141",
        "conformation": 8.26,
        "abilities": 8.1,
        "totalScore": 8.17,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2004156275",
        "name": "Gígur",
        "origin": "Hólabaki",
        "colorCode": "09000",
        "country": "NO",
        "year": 2008,
        "competition": "Héraðssýning í Húnaþingi 2008",
        "judgeCountry": "IS",
        "exhibitor": "Ólafur Magnússon",
        "owner": "Trine Jonassen",
        "m1": "140",
        "conformation": 8.01,
        "abilities": 7.83,
        "totalScore": 7.9,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2002256274",
        "name": "Gerpla",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "IS",
        "year": 2007,
        "competition": "Héraðssýning í Húnaþingi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "143",
        "conformation": 8.11,
        "abilities": 7.91,
        "totalScore": 7.99,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2003156270",
        "name": "Sigur",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "AT",
        "year": 2007,
        "competition": "Héraðssýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Mag. Gerrit Sager",
        "m1": "141",
        "conformation": 8.24,
        "abilities": 7.85,
        "totalScore": 8.01,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2003156270",
        "name": "Sigur",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "AT",
        "year": 2007,
        "competition": "Fjórðungsmót  á Austurlandi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Mag. Gerrit Sager",
        "m1": "141",
        "conformation": 8.24,
        "abilities": 7.8,
        "totalScore": 7.98,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2002256274",
        "name": "Gerpla",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "IS",
        "year": 2007,
        "competition": "Síðsumarsýning á Blönduósi",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "140",
        "conformation": 8.01,
        "abilities": 7.62,
        "totalScore": 7.78,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1997256337",
        "name": "Eva",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "DE",
        "year": 2006,
        "competition": "Pfaffenbuck-Unterbronnen",
        "judgeCountry": "DE",
        "exhibitor": "Thorsten Reisinger",
        "owner": "Belinda Dettinger",
        "m1": "132",
        "conformation": 7.87,
        "abilities": 8.04,
        "totalScore": 7.97,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1997256333",
        "name": "Ljósbrá",
        "origin": "Hólabaki",
        "colorCode": "12000",
        "country": "IS",
        "year": 2006,
        "competition": "Héraðssýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Magnús Bragi Magnússon",
        "owner": "Högni Fróðason, Högni Fróðason",
        "m1": "139",
        "conformation": 7.68,
        "abilities": 8.25,
        "totalScore": 8.02,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS2002156274",
        "name": "Heiðar",
        "origin": "Hólabaki",
        "colorCode": "15210",
        "country": "NO",
        "year": 2006,
        "competition": "Héraðssýning í Eyjafirði",
        "judgeCountry": "IS",
        "exhibitor": "Páll Helgi Valdemarsson",
        "owner": "Ármann Ólafsson",
        "m1": "140",
        "conformation": 8.13,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1996256273",
        "name": "Perla",
        "origin": "Hólabaki",
        "colorCode": "01000",
        "country": "IS",
        "year": 2006,
        "competition": "Síðsumarsýning á Gaddstaðaflötum",
        "judgeCountry": "IS",
        "exhibitor": "Jón Gíslason",
        "owner": "Þröstur Arnar Sigurvinsson",
        "m1": "136",
        "conformation": 7.88,
        "abilities": 7.49,
        "totalScore": 7.65,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2002256274",
        "name": "Gerpla",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "IS",
        "year": 2006,
        "competition": "Landsmót 2006 - Vindheimamelar",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "140",
        "conformation": 7.9,
        "abilities": 7.67,
        "totalScore": 7.76,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS2002256274",
        "name": "Gerpla",
        "origin": "Hólabaki",
        "colorCode": "17200",
        "country": "IS",
        "year": 2006,
        "competition": "Héraðssýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "140",
        "conformation": 7.9,
        "abilities": 7.88,
        "totalScore": 7.89,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1996256273",
        "name": "Perla",
        "origin": "Hólabaki",
        "colorCode": "01000",
        "country": "IS",
        "year": 2005,
        "competition": "Síðsumarsýning Norðurlands",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Þröstur Arnar Sigurvinsson",
        "m1": "132",
        "conformation": 7.88,
        "abilities": 7.71,
        "totalScore": 7.78,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1999256275",
        "name": "Gola",
        "origin": "Hólabaki",
        "colorCode": "15200",
        "country": "DK",
        "year": 2004,
        "competition": "Héraðssýning Húnaþingi",
        "judgeCountry": "IS",
        "exhibitor": "Valur Kristján Valsson",
        "owner": "Jan Broch",
        "m1": "142",
        "conformation": 7.57,
        "abilities": 7.25,
        "totalScore": 7.38,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS1996256334",
        "name": "Fía",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "IS",
        "year": 2004,
        "competition": "Héraðssýning á Gaddstaðaflötum",
        "judgeCountry": "IS",
        "exhibitor": "Vignir Siggeirsson",
        "owner": "Kjartan Sveinsson",
        "m1": "136",
        "conformation": 7.83,
        "abilities": 7.99,
        "totalScore": 7.93,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1996256334",
        "name": "Fía",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "IS",
        "year": 2004,
        "competition": "Síðsumarsýning á Gaddstaðaflötum",
        "judgeCountry": "IS",
        "exhibitor": "Vignir Siggeirsson",
        "owner": "Kjartan Sveinsson",
        "m1": "135",
        "conformation": 7.76,
        "abilities": 8.14,
        "totalScore": 7.99,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1996256277",
        "name": "Sigurdís",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2004,
        "competition": "Landsmót 2004 - Hella",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "140",
        "conformation": 8.38,
        "abilities": 8.13,
        "totalScore": 8.23,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1996256277",
        "name": "Sigurdís",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2004,
        "competition": "Vorsýning á Sauðárkróki",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "140",
        "conformation": 8.38,
        "abilities": 8.05,
        "totalScore": 8.18,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1995256275",
        "name": "Spurning",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2003,
        "competition": "Héraðssýning Kópavogi",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Hjörtur Karl Einarsson",
        "m1": "141",
        "conformation": 7.96,
        "abilities": 7.95,
        "totalScore": 7.96,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1996256334",
        "name": "Fía",
        "origin": "Hólabaki",
        "colorCode": "35000",
        "country": "IS",
        "year": 2003,
        "competition": "Héraðssýning Húnaþingi",
        "judgeCountry": "IS",
        "exhibitor": "Sverrir Sigurðsson",
        "owner": "Kjartan Sveinsson",
        "m1": "133",
        "conformation": 7.9,
        "abilities": 7.4,
        "totalScore": 7.6,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1997256275",
        "name": "Þokkadís",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "US",
        "year": 2003,
        "competition": "Héraðssýning Húnaþingi",
        "judgeCountry": "IS",
        "exhibitor": "Valur Kristján Valsson",
        "owner": "Patricia Grimmer",
        "m1": "133",
        "conformation": 8.01,
        "abilities": 7.28,
        "totalScore": 7.57,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1997256273",
        "name": "Harpa",
        "origin": "Hólabaki",
        "colorCode": "12000",
        "country": "US",
        "year": 2003,
        "competition": "Héraðssýning Húnaþingi",
        "judgeCountry": "IS",
        "exhibitor": "Herdís Reynisdóttir",
        "owner": "Þingeyrabúið ehf",
        "m1": "142",
        "conformation": 7.81,
        "abilities": 6.91,
        "totalScore": 7.27,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS1997256335",
        "name": "Dama",
        "origin": "Hólabaki",
        "colorCode": "01000",
        "country": "IS",
        "year": 2002,
        "competition": "Héraðssýning í Skagafirði",
        "judgeCountry": "IS",
        "exhibitor": "Jón Kristófer Sigmarsson",
        "owner": "Ingimar Skaftason",
        "m1": "139",
        "conformation": 8.13,
        "abilities": 7.1,
        "totalScore": 7.51,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS1997256274",
        "name": "Perla",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "IS",
        "year": 2002,
        "competition": "Héraðssýning í Húnaveri",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "138",
        "conformation": 8,
        "abilities": 7.5,
        "totalScore": 7.7,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1995256275",
        "name": "Spurning",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2002,
        "competition": "Héraðssýning á Gaddstaðaflötum",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Hjörtur Karl Einarsson",
        "m1": "139",
        "conformation": 8.02,
        "abilities": 7.95,
        "totalScore": 7.98,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1995256275",
        "name": "Spurning",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2002,
        "competition": "Síðsumarsýning á Gaddstaðaflötum",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Hjörtur Karl Einarsson",
        "m1": "140",
        "conformation": 7.98,
        "abilities": 7.99,
        "totalScore": 7.99,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1997256333",
        "name": "Ljósbrá",
        "origin": "Hólabaki",
        "colorCode": "12000",
        "country": "IS",
        "year": 2002,
        "competition": "Síðsumarsýning Melgerðismelum",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Högni Fróðason, Högni Fróðason",
        "m1": "136",
        "conformation": 7.59,
        "abilities": 7.66,
        "totalScore": 7.63,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1996256277",
        "name": "Sigurdís",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2001,
        "competition": "Síðsumarsýning Vindheimamelum",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "138",
        "conformation": 8.27,
        "abilities": 7.77,
        "totalScore": 7.97,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1997256274",
        "name": "Perla",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "IS",
        "year": 2001,
        "competition": "Húnaver 2001",
        "judgeCountry": "IS",
        "exhibitor": "Elsa Albertsdóttir",
        "owner": "Björn Magnússon",
        "m1": "135",
        "conformation": 7.87,
        "abilities": 7.26,
        "totalScore": 7.51,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1995256276",
        "name": "Tvista",
        "origin": "Hólabaki",
        "colorCode": "15400",
        "country": "IS",
        "year": 2001,
        "competition": "Húnaver 2001",
        "judgeCountry": "IS",
        "exhibitor": "Erlingur Ingvarsson",
        "owner": "Björn Magnússon",
        "m1": "136",
        "conformation": 7.68,
        "abilities": 7.1,
        "totalScore": 7.33,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS1996256277",
        "name": "Sigurdís",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2001,
        "competition": "Húnaver 2001",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "139",
        "conformation": 8.14,
        "abilities": 7.74,
        "totalScore": 7.9,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1992256275",
        "name": "Dreyra",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2000,
        "competition": "Víðidalur seinni sýning",
        "judgeCountry": "IS",
        "exhibitor": "",
        "owner": "Björn Magnússon",
        "m1": "141",
        "conformation": 7.63,
        "abilities": 7.93,
        "totalScore": 7.81,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1995256276",
        "name": "Tvista",
        "origin": "Hólabaki",
        "colorCode": "15400",
        "country": "IS",
        "year": 2000,
        "competition": "Húnaver",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "137",
        "conformation": 7.66,
        "abilities": 7.36,
        "totalScore": 7.48,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS1996256277",
        "name": "Sigurdís",
        "origin": "Hólabaki",
        "colorCode": "16000",
        "country": "IS",
        "year": 2000,
        "competition": "Húnaver",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "136",
        "conformation": 8.14,
        "abilities": 7.32,
        "totalScore": 7.65,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1996256276",
        "name": "Elding",
        "origin": "Hólabaki",
        "colorCode": "15000",
        "country": "IS",
        "year": 2000,
        "competition": "Húnaver",
        "judgeCountry": "IS",
        "exhibitor": "Tryggvi Björnsson",
        "owner": "Björn Magnússon",
        "m1": "135",
        "conformation": 7.39,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "CA"
      },
      {
        "id": "IS1991156276",
        "name": "Glaður",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "DE",
        "year": 1999,
        "competition": "World Championship Rieden",
        "judgeCountry": "DE",
        "exhibitor": "Hinrik Bragason",
        "owner": "Björn Magnússon",
        "m1": "141",
        "conformation": 8.33,
        "abilities": 8.46,
        "totalScore": 8.41,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1991156276",
        "name": "Glaður",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "DE",
        "year": 1999,
        "competition": "Isländische Zuchtprüfung, Osterbyholz",
        "judgeCountry": "DE",
        "exhibitor": "Hinrik Bragason",
        "owner": "Björn Magnússon",
        "m1": "141",
        "conformation": 8.3,
        "abilities": 8.65,
        "totalScore": 8.47,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1993256273",
        "name": "Stund",
        "origin": "Hólabaki",
        "colorCode": "93000",
        "country": "SE",
        "year": 1998,
        "competition": "Regional bedömning - Sörgården",
        "judgeCountry": "SE",
        "exhibitor": "",
        "owner": "Hjörtur Karl Einarsson kt: IS1707533059",
        "m1": "",
        "conformation": 7.82,
        "abilities": 7.27,
        "totalScore": 7.49,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS1991156276",
        "name": "Glaður",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "DE",
        "year": 1997,
        "competition": "Vorsýning í Gunnarsholti",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Björn Magnússon",
        "m1": "141",
        "conformation": 8.28,
        "abilities": 8.54,
        "totalScore": 8.41,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1991156276",
        "name": "Glaður",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "DE",
        "year": 1997,
        "competition": "Héraðssýning á Gaddstaðaflötum",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Björn Magnússon",
        "m1": "141",
        "conformation": 8.25,
        "abilities": 8.57,
        "totalScore": 8.41,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1993256274",
        "name": "Gyðja",
        "origin": "Hólabaki",
        "colorCode": "32000",
        "country": "NO",
        "year": 1997,
        "competition": "Héraðssýning í Húnaveri",
        "judgeCountry": "IS",
        "exhibitor": "",
        "owner": "Tina Kirkaas Ugland",
        "m1": "138",
        "conformation": 7.68,
        "abilities": 7.96,
        "totalScore": 7.82,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1991156276",
        "name": "Glaður",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "DE",
        "year": 1997,
        "competition": "World Championship Seljord",
        "judgeCountry": "NO",
        "exhibitor": "Sigurður Matthiasson",
        "owner": "Björn Magnússon",
        "m1": "139",
        "conformation": 8.3,
        "abilities": 8.11,
        "totalScore": 8.2,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1991156276",
        "name": "Glaður",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "DE",
        "year": 1996,
        "competition": "Vorsýning í Gunnarsholti, Rang",
        "judgeCountry": "IS",
        "exhibitor": "Sigurður Vignir Matthíasson",
        "owner": "Björn Magnússon",
        "m1": "139",
        "conformation": 8.18,
        "abilities": 8.06,
        "totalScore": 8.12,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1991156276",
        "name": "Glaður",
        "origin": "Hólabaki",
        "colorCode": "34000",
        "country": "DE",
        "year": 1995,
        "competition": "Héraðssýning í Húnaveri",
        "judgeCountry": "IS",
        "exhibitor": "",
        "owner": "Björn Magnússon",
        "m1": "136",
        "conformation": 8.28,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "DMRT3 arfgerðarspá",
        "genetics": "AA"
      },
      {
        "id": "IS1985156003",
        "name": "Nátthrafn (Andvari)",
        "origin": "Hólabaki",
        "colorCode": "25200",
        "country": "IS",
        "year": 1988,
        "competition": "Fjórðungsmót Kaldármelum",
        "judgeCountry": "IS",
        "exhibitor": "",
        "owner": "Hildur Claessen",
        "m1": "144",
        "conformation": 7.71,
        "abilities": "",
        "totalScore": "",
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
      {
        "id": "IS1967256335",
        "name": "Ör",
        "origin": "Hólabaki",
        "colorCode": "12020",
        "country": "IS",
        "year": 1973,
        "competition": "Dómur ekki skráður á sérstaka sýningu.",
        "judgeCountry": "",
        "exhibitor": "",
        "owner": "",
        "m1": "136",
        "conformation": 7.4,
        "abilities": 7.2,
        "totalScore": 7.3,
        "abilitiesNoGait": "",
        "totalScoreNoGait": "",
        "geneticAnalysis": "",
        "genetics": ""
      },
  {
    "id": "IS2022156274",
    "name": "Draumur",
    "origin": "Hólabaki",
    "colorCode": "62500",
    "country": "IS",
    "year": 2026,
    "competition": "Vorsýning Akureyri, dagana 8. til 12. júní.",
    "judgeCountry": "IS",
    "exhibitor": "Agnar Þór Magnússon",
    "owner": "Björn Magnússon",
    "m1": "144",
    "conformation": 8.4,
    "abilities": "",
    "totalScore": 8.4,
    "abilitiesNoGait": "",
    "totalScoreNoGait": "",
    "geneticAnalysis": "DMRT3 arfgerðarspá",
    "genetics": "AA"
  },
  {
    "id": "IS2022156276",
    "name": "Fróði",
    "origin": "Hólabaki",
    "colorCode": "34000",
    "country": "IS",
    "year": 2026,
    "competition": "Vorsýning Sörlastöðum, dagana 1. til 5. júní. Vika I.",
    "judgeCountry": "IS",
    "exhibitor": "Sigurður Steingrímsson",
    "owner": "Björn Magnússon, Georg Kristjánsson, Sigurður Steingrímsson",
    "m1": "148",
    "conformation": 8.24,
    "abilities": "",
    "totalScore": 8.24,
    "abilitiesNoGait": "",
    "totalScoreNoGait": "",
    "geneticAnalysis": "DMRT3 arfgerðarspá",
    "genetics": "AA"
  },
  {
    "id": "IS2022156270",
    "name": "Óliver",
    "origin": "Hólabaki",
    "colorCode": "15000",
    "country": "IS",
    "year": 2026,
    "competition": "Vorsýning Akureyri, dagana 8. til 12. júní.",
    "judgeCountry": "IS",
    "exhibitor": "Agnar Þór Magnússon",
    "owner": "Björn Magnússon",
    "m1": "147",
    "conformation": 8.25,
    "abilities": 8.16,
    "totalScore": 8.19,
    "abilitiesNoGait": 8.28,
    "totalScoreNoGait": 8.27,
    "geneticAnalysis": "DMRT3 arfgerðarspá",
    "genetics": "AA"
  },
  {
    "id": "IS2019256275",
    "name": "Hugrún",
    "origin": "Hólabaki",
    "colorCode": "12000",
    "country": "IS",
    "year": 2026,
    "competition": "Vorsýning Víðidal Reykjavík, dagana 15. til 19. júní.",
    "judgeCountry": "IS",
    "exhibitor": "Þorvaldur Árni Þorvaldsson",
    "owner": "Hjörtur Karl Einarsson, Sigríður S Sigþórsdóttir",
    "m1": "142",
    "conformation": 8.32,
    "abilities": 8.55,
    "totalScore": 8.47,
    "abilitiesNoGait": 8.83,
    "totalScoreNoGait": 8.65,
    "geneticAnalysis": "DMRT3 arfgerðarspá",
    "genetics": "CA"
  },
  {
    "id": "IS2020256275",
    "name": "Heiðrún",
    "origin": "Hólabaki",
    "colorCode": "27000",
    "country": "IS",
    "year": 2026,
    "competition": "Vorsýning Víðidal í Reykjavík, dagana 22. til 24. júní.",
    "judgeCountry": "IS",
    "exhibitor": "Helga Una Björnsdóttir",
    "owner": "Björn Magnússon",
    "m1": "142",
    "conformation": 7.97,
    "abilities": 8.02,
    "totalScore": 8,
    "abilitiesNoGait": 8.56,
    "totalScoreNoGait": 8.36,
    "geneticAnalysis": "DMRT3 arfgerðarspá",
    "genetics": "CA"
  }      
  ];
  
  // Hjálparfall til að finna alla dóma fyrir ákveðinn hest
  export const getEvaluationsForHorse = (horseId) => {
    return evaluationData.filter(evaluation => evaluation.id === horseId);
  };
  
  // Hjálparfall til að finna nýjustu dóminn fyrir hest
  export const getLatestEvaluationForHorse = (horseId) => {
    const evaluations = getEvaluationsForHorse(horseId);
    if (evaluations.length === 0) return null;
    
    return evaluations.reduce((latest, current) => {
      return current.year > latest.year ? current : latest;
    });
  };
  
  // Hjálparfall til að fá meðaltal af öllum dómum fyrir hest
  export const getAverageScoresForHorse = (horseId) => {
    const evaluations = getEvaluationsForHorse(horseId);
    const validEvaluations = evaluations.filter(e => e.totalScore !== null);
    
    if (validEvaluations.length === 0) return null;
    
    const totals = validEvaluations.reduce((acc, evaluation) => ({
      conformation: acc.conformation + (evaluation.conformation || 0),
      abilities: acc.abilities + (evaluation.abilities || 0),
      totalScore: acc.totalScore + evaluation.totalScore,
      count: acc.count + 1
    }), { conformation: 0, abilities: 0, totalScore: 0, count: 0 });
    
    return {
      conformation: (totals.conformation / totals.count).toFixed(2),
      abilities: (totals.abilities / totals.count).toFixed(2),
      totalScore: (totals.totalScore / totals.count).toFixed(2),
      evaluationCount: totals.count
    };
  };